import { render, staticRenderFns } from "./global.vue?vue&type=template&id=58ad485a&"
import script from "./global.vue?vue&type=script&lang=js&"
export * from "./global.vue?vue&type=script&lang=js&"
import style0 from "./global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports